<script setup>
import {computed, onMounted, reactive, ref} from 'vue'
import DeviceScreenshot from '@common/DeviceScreenshot'
import Keyboard from '@common/Keyboard'
import {Inertia} from '@inertiajs/inertia'
import {useBreadStore} from '@bread/js/store'
import {DateTime} from 'luxon'
import LogViewer from "@common/LogViewer";

const store = useBreadStore()
const selected = reactive({})
let channel = reactive({})
const screenshots = reactive({})
const logs = reactive({})
let keyboardInput = ref('')
let keyPress = ref('')

onMounted(() => {
  store.setResource('device')
})

const selectDevice = (device) => {
  if (selected.device?.id === device.id) {
    notify({event: 'left', data: selected.device})
    window.Echo.leave(`devices.${selected.device.external_identifier}`)
    selected.device = null
  } else {
    channel = window.Echo.private(`devices.${device.external_identifier}`)
    channel.listen('.client-screenshot', (data) => {
      console.log(data)
      screenshots[data.identifier] = data.filename + '?' + +new Date()
    })
    setTimeout(() => {
      selected.device = device
      channel.whisper('joined', {device: selected.device})
    }, 1000)
  }
}

const sendKeyboardInput = () => {
  notify({event: 'type', data: {string: keyboardInput.value}})
  keyboardInput.value = ''
}

const sendKeyboardPress = (data) => {
  notify({event: 'press', data})
  keyboardInput.value = ''
}

const notify = (data) => {
  console.log(data.event, data.data)
  channel.whisper(data.event, data.data)
}

const deselectDevice = () => {
  selected.device = null
}

onMounted(() => {
  for (let device of Inertia.page.props.devices) {
    logs[device.external_identifier] = device.logs
    screenshots[device.external_identifier] = device.latest_screenshot
  }
})

const logOpen = ref(false)
let openLogFile = ref('')
let openLogContents = ref('')
let logDevice = ref({})

const showLog = (device, filename, contents) => {
  openLogFile.value = filename;
  openLogContents.value = contents;
  logOpen.value = true;
  logDevice.value = device;
}
const closeLog = () => {
  logOpen.value = false;
}
</script>

<template>
  <div class="flex h-full w-full flex-col items-center justify-center">
    <div
      style="height: 75vh"
      class="flex w-full items-center justify-center bg-gray-700 py-4"
    >
      <div class="flex" v-if="selected.device">
        <DeviceScreenshot
          :device="selected.device"
          @clicked="notify"
          :src="screenshots[selected.device.external_identifier]"
          style="max-height: 70vh"
          class="max-h-full"
          :isSelectedDevice="true"
        >
        </DeviceScreenshot>
        <div>
          <Keyboard
            @pressed="sendKeyboardPress"
            :device="selected.device"
          ></Keyboard>
        </div>
      </div>
      <div
        v-else
        class="flex h-full w-full items-center justify-center text-white"
      >
        Kies een toestel hieronder...
      </div>
    </div>
    <div class="flex h-full flex-wrap flew-row mt-6 justify-between w-full">
      <div class="card w-96 bg-base-50 shadow-xl"
           :class="device.id === selected.device?.id ? 'bg-primary text-priamry-content' : ''"
           v-for="device in $attrs.devices" >
        <div class="card-body">
          <h2 class="card-title">
            {{ device.node_name }}
            <div class="badge badge-info"> {{ parseInt(device.temperature) }} °C</div>
          </h2>
          <p v-if="device.last_seen">
            Laatst Gezien op
            {{
              DateTime.fromISO(device.last_seen).toLocaleString({
                locale: 'nl',
                ...DateTime.DATETIME_MED,
              })
            }}
          </p>
          <div class="card-actions">
            <button class="btn btn-success" @click="selectDevice(device)"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z" />
            </svg>
            </button>
            <button class="btn btn-danger gap-2"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>

              Device</button>
            <button class="btn btn-danger gap-2"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
              PC</button>
            <!--            <div v-for="log in logs[device.external_identifier]" @click="showLog(device, log.filename, log.contents)" class="badge badge-outline">{{ log.filename }}</div>-->
          </div>
        </div>
        <figure>
          <DeviceScreenshot
            :device="device"
            :src="screenshots[device.external_identifier]"
            :isSelectedDevice="false"></DeviceScreenshot>
        </figure>
      </div>
    </div>
    <!--    <div class="w-full flex flex-wrap flex-row bg-white p-5 rounded-md" v-if="selected.device">-->
    <!--      <h2 class="cursor-pointer mb-5 flex items-center justify-between border-b border-gray-200 pb-3 font-bold w-full">Geschiedenis</h2>-->
    <!--      <div class="" v-for="(screenshot, timestamp) in selected.device.screenshots">-->
    <!--        <img class="p-2 w-64" :src="screenshot" alt="">-->
    <!--        <p>{{timestamp}}</p>-->
    <!--      </div>-->
    <!--    </div>-->
    <LogViewer v-if="logOpen" :filename="openLogFile" :device="logDevice" @close="closeLog()"></LogViewer>
  </div>
</template>
